import { useSelector } from "react-redux";
import store from "../storeWire";
import { SET_CART_LOADER_DATA_OBJECT, getCartCount, getValidateCartFromServer, mergeGuestCartItems, set_cart_tax, fetchCartTax, SET_CART_BEFORE_TO_SEND_SERVER_SINGLE_PRODUCT, getComplianceData } from "../store/slice/model/Cart";
import CartAPICall from "../service/CartAPICall";
import CartRepository from "src/repository/CartRepository";
import System from "src/helper/system";

export function useCartStore() {
    const CART_DATA = useSelector((state) => state.entities.Cart.CART_DATA);
    const CART_BEFORE_TO_SEND_SERVER = useSelector((state) => state.entities.Cart.CART_BEFORE_TO_SEND_SERVER);
    const CART_PRICE_BEFORE_TO_SEND_SERVER = useSelector((state) => state.entities.Cart.CART_PRICE_BEFORE_TO_SEND_SERVER);
    const CART_LOADER_DATA_OBJECT = useSelector((state) => state.entities.Cart.CART_LOADER_DATA_OBJECT);
    const ADD_CART_DATA = useSelector((state) => state.entities.Cart.ADD_CART_DATA);
    const CART_COUNT = useSelector((state) => state.entities.Cart.CART_COUNT);
    const WEB_ORDER_ID = useSelector((state) => state.entities.Cart.WEB_ORDER_ID);
    const CART_SUB_TOTAL = useSelector((state) => state.entities.Cart.CART_SUB_TOTAL);
    const VALIDATE_CART = useSelector((state) => state.entities.Cart.VALIDATE_CART)
    const CART_TAX_TARIFF = useSelector((state) => state.entities.Cart.CART_TAX_TARIFF)
    const MERGE_CART = useSelector((state) => state.entities.Cart.mergeCart)
    const COMPLIANCE_DATA = useSelector((state) => state.entities.Cart.COMPLIANCE_DATA)
    const CART_PRODUCTS = JSON.parse(localStorage.getItem(System.storageName.CART_PRODUCT_DATA))

    let data = {
        CART_DATA,
        CART_BEFORE_TO_SEND_SERVER,
        CART_PRICE_BEFORE_TO_SEND_SERVER,
        CART_LOADER_DATA_OBJECT,
        ADD_CART_DATA,
        CART_COUNT,
        WEB_ORDER_ID,
        CART_SUB_TOTAL,
        VALIDATE_CART,
        CART_TAX_TARIFF,
        MERGE_CART,
        COMPLIANCE_DATA,
        CART_PRODUCTS
    };
    let fetch = {
        check_item_exists_in_cart: async (params) => {
            return await new CartRepository().checkItemExistsInCart(params)
        },
        fetch_cart_count: async (params) => {
            return await store.dispatch(getCartCount(params))
        },
        fetch_cart_data: async (param) => {
            return await new CartRepository().fetchCartData(param)
        },
        fetch_cart_tax: async (params) => {
            return await store.dispatch(fetchCartTax(params));
        },
        // initiatedKernelCall: async (params) => {
        //     await new CartRepository().initiatedKernelCall(params);
        // },
        update_To_Cart_Server: async (params) => {
            await new CartRepository().updateToCartServer(params);
        },
        clear_single_cart_product: async (params) => {
            return await new CartRepository().clearSingleCartProduct(params);
        },
        schedule_Shipping_Apply: async (params) => {
            await new CartRepository().scheduleShippingApply(params);
        },
        // not in use
        // Schedule_Shipping_View: async (params) => {
        //     await store.dispatch(getShippingScheduleDate(params))
        // },
        get_display_status_button: (Product, Pricing, Inventory, type, extraParams = {}) => {
            return new CartRepository().getDisplayStatusButton(Product, Pricing, Inventory, type, extraParams)
        },
        update_BackOrder_Quantity_ToCartServer: async (cartDetailItems) => {
            return await new CartRepository().updateBackOrderQuantityToCartServer(cartDetailItems)
        },
        get_Validate_Cart_From_Server: async (param) => {
            return await store.dispatch(getValidateCartFromServer(param))
        },
        merge_Guest_Cart_Items: async () => {
            return await store.dispatch(mergeGuestCartItems())
        },
        get_cart_products: () => {
            return JSON.parse(localStorage.getItem(System.storageName.CART_PRODUCT_DATA))
        },
        get_payment_token: () => {
            return new CartRepository().getPaymentToken();
        },
        get_compliance_data: async (param) => {
            return await store.dispatch(getComplianceData(param))
        },
        backorder_not_available: (single_product) => {
            return new CartRepository().backorderNotAvailable(single_product);
        }
    };
    let set = {
        add_cart_in_Bulk: async (params) => {
            return await new CartRepository().addCartInBulk(params)
        },
        set_cart_loader_data_object: async (params) => {
            return await store.dispatch(SET_CART_LOADER_DATA_OBJECT(params))
        },
        replace_cart_in_Bulk: async (params, isBulk = false) => {
            return new CartRepository().replaceCartInBulk(params, isBulk)
        },
        clear_cart: async (params) => {
            await new CartRepository().clearAllCartFromServer();
            await new CartRepository().fetchCartData(params);
        },
        ADD_TO_CART: async (param, isFrom, productData, isManuallyAddCart) => {
            return await new CartRepository().addToCartServer(param, isFrom, productData, isManuallyAddCart);
        },
        add_compliance_data: async (param) => {
            return await new CartRepository().addComplianceData(param);
        },
        set_cart_tax: async (params) => {
            return await store.dispatch(set_cart_tax(params))
        },
        SET_CART_BEFORE_TO_SEND_SERVER_SINGLE_PRODUCT: (product) => {
            store.dispatch(SET_CART_BEFORE_TO_SEND_SERVER_SINGLE_PRODUCT({ CART_DATA: product }));
        }

    };

    let exportCartItems = {
        export_cart_data: async (fileType) => {
            return await new CartAPICall().exportCartData(fileType)
        }
    }

    return [data, fetch, set, exportCartItems]
}